import { z } from 'zod';
// --- Shared field schemas ---
/** 1-255 chars, alphanumeric + underscore + hyphen */
export const visitorIdSchema = z
    .string()
    .min(1)
    .max(255)
    .regex(/^[a-zA-Z0-9_-]+$/, 'Alphanumeric, underscore, or hyphen only')
    .meta({
    description: 'Anonymous visitor identifier (alphanumeric, underscore, or hyphen)',
    example: 'user_abc123',
});
/** Open identity model — type is a source descriptor, not a closed enum */
export const identitySchema = z
    .object({
    type: z
        .string()
        .min(1)
        .max(100)
        .regex(/^[a-z0-9_]+$/, 'Lowercase alphanumeric + underscore only')
        .meta({
        description: 'Source descriptor (e.g., email, om_account, sfdc_contact)',
        example: 'email',
    }),
    value: z
        .string()
        .min(1)
        .max(500)
        .meta({ description: 'The identity value', example: 'user@example.com' }),
})
    .meta({ id: 'Identity', description: 'Open identity model linking a visitor to a known entity' });
/** ISO 8601 timestamp, must be within 24 hours of server time */
export const eventTimestampSchema = z
    .string()
    .datetime()
    .refine((ts) => {
    const delta = Math.abs(Date.now() - new Date(ts).getTime());
    return delta <= 24 * 60 * 60 * 1000;
}, { error: 'Timestamp must be within 24 hours of current time' })
    .meta({
    description: 'ISO 8601 timestamp, must be within 24 hours of server time',
    example: '2026-04-10T14:30:00.000Z',
});
// --- Phone / E.164 helper ---
/** E.164 phone number format: +<country><subscriber>, 8–15 digits total. */
export const e164Regex = /^\+[1-9]\d{7,14}$/;
/**
 * Validate a phone identity value is E.164 format.
 * Used as a runtime guard only — the identity schema remains open.
 * Callers should normalize to E.164 before passing `type: 'phone'` to `identify()`.
 */
export function isValidE164(value) {
    return e164Regex.test(value);
}
// --- Error response ---
export const errorResponseSchema = z
    .object({
    error: z.string(),
    message: z.string().optional(),
    details: z.unknown().optional(),
})
    .meta({ id: 'ErrorResponse', description: 'Standard error response' });
//# sourceMappingURL=common.js.map